import React from 'react';
import { useNavigate } from 'react-router';
import {
  PopupContainer,
  PopupHeader,
  PopupName,
  PopupEmail,
  PopupList,
  PopupItem,
  Divider
} from './Popup.styles';
import { IoPersonOutline, IoSettingsOutline, IoExitOutline } from 'react-icons/io5';

type Props = {
  name: string;
  email: string;
  onCloseMenu?: () => void;
};

const Popup: React.FC<Props> = ({ name, email, onCloseMenu }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch('/api/session/logout', { method: 'POST', credentials: 'include' });
    } catch (e) {
      console.error('Logout request failed', e);
    } finally {
      localStorage.removeItem('userId');
      window.location.replace('/');
    }
  };

  return (
    <PopupContainer role="menu" aria-label="User menu">
      <PopupHeader>
        <PopupName>{name}</PopupName>
        <PopupEmail>{email}</PopupEmail>
      </PopupHeader>
      <PopupList>
        <PopupItem><IoPersonOutline size={18} /> Profile</PopupItem>
        <Divider />
        <PopupItem
          onClick={() => {
            onCloseMenu?.();
            navigate('/settings');
          }}
        >
          <IoSettingsOutline size={18} /> Settings
        </PopupItem>
        <Divider />
        <PopupItem onClick={handleLogout}><IoExitOutline size={18} /> Log out</PopupItem>
      </PopupList>
    </PopupContainer>
  );
};

export default Popup;


